module.exports = __webpack_public_path__ + "img/img-kingmaker.65d937af.png";